<div class="w-100 overflow mb-2">
    <div class="float-end">
        <cancel-button #cancel class="me-1" (onClick)="onCancel ($event)"></cancel-button>
        <submit-button #submit (onClick)="onSubmit ($event)" ></submit-button>
    </div>
</div>
